module.exports = __webpack_public_path__ + "img/LOGO-GOV.00d96eac.svg";